{
  "name": "frontend",
  "version": "2.17.0",
  "private": true,
  "description": "Frontend for Fundraising SaaS",
  "dependencies": {
    "@chakra-ui/react": "~3.37.0",
    "@emotion/react": "~11.14.0",
    "@ramonak/react-progress-bar": "~5.4.0",
    "@tanstack/react-table": "~9.3.1",
    "@tanstack/react-virtual": "~3.14.25",
    "apexcharts": "^8.7.0",
    "chakra-react-select": "^6.1.3",
    "country-flag-icons": "~1.6.20",
    "date-fns": "^4.4.0",
    "next-themes": "^0.4.6",
    "process": "^0.11.10",
    "react": "^19.3.1",
    "react-apexcharts": "~2.2.0",
    "react-avatar-editor": "~16.0.0",
    "react-dom": "^19.3.1",
    "react-dropzone": "~20.1.4",
    "react-ga4": "3.0.1",
    "react-hook-form": "^7.91.0",
    "react-icons": "~5.7.0",
    "react-number-format": "~5.4.5",
    "react-router-dom": "~7.18.5",
    "react-slick": "~0.31.0"
  },
  "scripts": {
    "clean": "rm -Rf node_modules/ build/ package-lock.json",
    "version": "echo $npm_package_version",
    "start": "vite",
    "local": "VITE_API_HOST=http://localhost:9301 vite",
    "typecheck": "tsc --noEmit --pretty false",
    "typecheck:strict": "tsc -p tsconfig.strict.json --noEmit --pretty false",
    "build": "npm run typecheck && vite build",
    "preview": "vite preview",
    "test": "vitest --run",
    "test:ui": "vitest --ui"
  },
  "eslintConfig": {
    "extends": [
      "react-app"
    ],
    "overrides": [
      {
        "files": [
          "src/api/*.ts"
        ],
        "rules": {
          "import/first": "off",
          "eqeqeq": "off"
        }
      }
    ]
  },
  "browserslist": {
    "production": [
      ">0.2%",
      "not dead",
      "not op_mini all"
    ],
    "development": [
      "last 1 chrome version",
      "last 1 firefox version",
      "last 1 safari version"
    ]
  },
  "devDependencies": {
    "@testing-library/dom": "^10.4.0",
    "@testing-library/jest-dom": "~7.0.0",
    "@testing-library/react": "^16.3.2",
    "@testing-library/user-event": "~14.6.8",
    "@types/node": "^26.6.6",
    "@types/react": "^19.2.18",
    "@vitejs/plugin-react": "^6.2.1",
    "@vitest/ui": "^5.0.5",
    "jsdom": "^30.1.2",
    "typescript": "7.0.2",
    "vite": "^8.3.5",
    "vitest": "^5.1.0"
  }
}
